import classNames from 'classnames';

export const VariantIconSvg = ({
  active = false,
  backgroundColours,
  crossedOut = false,
  disabled = false,
  size = 36,
  text,
  textStyle = 'dark',
}: {
  active?: boolean;
  backgroundColours?: string[];
  crossedOut?: boolean;
  size?: 36 | 60;
  disabled?: boolean;
  text?: string;
  textStyle?: 'light' | 'dark';
}) => {
  const outerBorderWidth = 2;
  const innerBorderWidth = 2;
  const cx = size / 2;
  const cy = size / 2;
  const innerOffset = outerBorderWidth + innerBorderWidth;
  const innerSize = size - 2 * innerOffset;
  const radius = 8;

  return (
    <svg
      className="absolute left-0 top-0 h-full w-full"
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer border */}
      <rect
        className={classNames(
          'transition-all duration-300',
          active ? 'fill-neutral-6' : 'fill-neutral-2',
          { 'group-hover:fill-neutral-4': !disabled },
        )}
        x={0}
        y={0}
        width={size}
        height={size}
        rx={radius}
      />

      {/* Inner border */}
      <rect
        className="fill-white"
        x={outerBorderWidth}
        y={outerBorderWidth}
        width={size - 2 * outerBorderWidth}
        height={size - 2 * outerBorderWidth}
        rx={radius - 2}
      />

      {/* Background when there is one colour */}
      {backgroundColours?.length === 1 && (
        <rect
          x={innerOffset}
          y={innerOffset}
          width={innerSize}
          height={innerSize}
          fill={backgroundColours[0]}
          rx={radius - 4}
        />
      )}

      {/* Background when there are multiple colours — vertical strips */}
      {backgroundColours && backgroundColours.length > 1 && (
        <>
          <defs>
            <clipPath id="inner-rect-clip">
              <rect
                x={innerOffset}
                y={innerOffset}
                width={innerSize}
                height={innerSize}
                rx={6}
              />
            </clipPath>
          </defs>
          <g clipPath="url(#inner-rect-clip)">
            {backgroundColours.map((colour, i) => {
              const stripWidth = innerSize / backgroundColours.length;
              return (
                <rect
                  key={i}
                  x={innerOffset + i * stripWidth}
                  y={innerOffset}
                  width={stripWidth}
                  height={innerSize}
                  fill={colour}
                />
              );
            })}
          </g>
        </>
      )}

      {/* Crossed out */}
      {crossedOut && (
        <line
          className="stroke-neutral-3"
          strokeWidth={2}
          x1={size - 2}
          y1={2}
          x2={2}
          y2={size - 2}
        />
      )}

      {/* Text */}
      {text && (
        <text
          alignmentBaseline="central"
          className={classNames('text-xs', {
            'fill-neutral-6': textStyle === 'dark',
            'fill-white': textStyle === 'light',
          })}
          textAnchor="middle"
          x={cx}
          y={cy}
        >
          {text}
        </text>
      )}
    </svg>
  );
};
